import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { LANDING_PATHS } from "@/lib/landingPaths";

const MainNavbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <motion.nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? "glass border-b border-white/5" : ""}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
      data-testid="choice-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center" data-testid="choice-logo">
            <img src="/images/logo.png" alt="FractoLabs" className="w-full max-w-[120px]" />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link
              to={LANDING_PATHS.roofing}
              className="text-gray-400 hover:text-white transition-colors text-sm font-medium"
            >
              Roofing Interceptor
            </Link>
            <Link
              to={LANDING_PATHS.realEstate}
              className="text-gray-400 hover:text-white transition-colors text-sm font-medium"
            >
              AI Broker
            </Link>
            <Link to="/contact" className="text-gray-400 hover:text-white transition-colors text-sm font-medium">
              Contact
            </Link>
            <Link to="/login" className="text-gray-400 hover:text-white transition-colors text-sm font-medium">
              Login
            </Link>
          </div>

          <div className="hidden md:block">
            <span className="badge-mono text-gray-500">DIGITAL EMPLOYEE · LIVE IN 72 HOURS</span>
          </div>
        </div>
      </div>
    </motion.nav>
  );
};

export default MainNavbar;
